<template>
  <div>
    <InputBox
      :label="label"
      :prop="searchKey"
      @input="handleInput"
      outputMode="flat"
    />
    <SelectBox
      v-if="resultList.length > 0"
      :options="resultList"
      :prop="prop"
      @input="handleSelect"
    />
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    prop: [String, Array, Object],
    searchKey: [String, Array, Object],
    input: Function,
    inputHandler: Function,
    // selectHandler: Function
  },
  data() {
    return {
      resultList: []
    }
  },
  methods: {
    async handleInput(val) {
      if (!val) {
        this.resultList = [];
      } else if (val.data.length > 0) {
        this.$emit('input', val);
        if (this.inputHandler) {
          const list = await this.inputHandler(val);
          this.resultList = list;
        }
      }
    },
    async handleSelect(val) {
      this.$emit('select', val);
      this.resultList = [];
    }
  }
}
</script>

<style>

</style>